import React, { useMemo, useState, useEffect } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import Switch from "@mui/material/Switch";
import { Button } from "react-bootstrap";
import SplitNumber from "../_Components/SplitNumber";
import { tools } from "../../../core/utils/tools";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import SwalMessage from "../_Components/SwalMessage";

function DataGrid({
  data,
  setShowModalReserveItem,
  setSelectedReserveItem,
  setModalType,
  setSelectedCheckBoxes,
  selectedCheckBoxes,
  setShowModalReserveItemPricingAndCommission
}) {
  const [lastSelected, setLastSelected] = useState(null);
  const changeSatusReserveItem = async (id) => {
    try {
      let response = await ApiAmusementServiceReserveItem.updateStatusAmusementServiceReserveItem({ id: id });
      if (response.succeeded == true) {
        document.getElementById("submitButton").click();
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      }
    } catch (error) {
    }
  };
  const handleToggle = (id, event) => {
    const isShiftPressed = event.shiftKey;
    if (isShiftPressed && lastSelected !== null) {
      // Find the range between lastSelected and current id
      const startIndex = data?.data?.findIndex((item) => item.id === lastSelected);
      const endIndex = data?.data?.findIndex((item) => item.id === id);
      const range = data?.data?.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1);
      const allIdsInRange = range.map((item) => item.id);

      // Add the first selected checkbox to the list if not already added
      setSelectedCheckBoxes((prevSelected) => {
        // Start by adding the first selected checkbox to the list
        const newSelected = [...prevSelected, lastSelected];

        // Now invert the checkboxes within the range
        allIdsInRange.forEach((checkboxId) => {
          const index = newSelected.indexOf(checkboxId);
          if (index === -1) {
            newSelected.push(checkboxId); // Add if not selected
          } else {
            newSelected.splice(index, 1); // Remove if already selected
          }
        });

        return newSelected;
      });
    } else {
      // If shift is not pressed, simply toggle the selection of this checkbox
      setSelectedCheckBoxes((prevSelected) =>
        prevSelected.includes(id) ? prevSelected.filter((selectedId) => selectedId !== id) : [...prevSelected, id],
      );
    }

    // Update the last selected checkbox
    setLastSelected(id);
  };

  const handleToggleAll = () => {
    if (data?.data?.length === selectedCheckBoxes.length) {
      setSelectedCheckBoxes([]);
    } else {
      const allCheckBoxesId = data?.data?.map((item) => item.id);
      setSelectedCheckBoxes([...allCheckBoxesId]);
    }
  };
  const columns = useMemo(() => [
    {
      accessor: "#",
      Header: () => {
        return (
          <div className="text-center cursor-pointer" onClick={() => handleToggleAll()}>
            <input
              type="checkbox"
              checked={data?.data?.length !== 0 && data?.data?.length === selectedCheckBoxes.length}
              onChange={() => { }}
              className="ml-1 ml-xl-6 pl-6 cursor-pointer"
            />
          </div>
        );
      },
      minWidth: 50,
      Cell: ({ row }) => (
        <div className="text-center cursor-pointer" onClick={(e) => handleToggle(row.original.id, e)}>
          <input
            type="checkbox"
            checked={selectedCheckBoxes.includes(row.original.id)}
            onChange={() => { }}
            className="ml-1 ml-xl-6 pl-6 cursor-pointer"
          />
        </div>
      ),
    },
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "title",
      Header: "آیتم",
      minWidth: 120,
    },
    {
      accessor: "amusementServiceName",
      Header: "تفریح",
      minWidth: 120,
    },

    {
      Header: "قیمت اصلی",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center success">
          <SplitNumber number={row.original.originalPrice} />
        </div>
      ),
    },
    {
      Header: "قیمت",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center success">
          <SplitNumber number={row.original.price} />
        </div>
      ),
    },

    {
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isActive ? true : false}
            value="row.original.isActive"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={() => changeSatusReserveItem(row.original.id)}
          />
        </div>
      ),
    },
    {
      accessor: "supplierAutoSettlement",
      Header: "تسویه خودکار با تامین کننده",
      minWidth: 100,
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch checked={row.original.supplierAutoSettlement} color="primary" />
        </div>
      ),
    },
    {
      accessor: "supplierSettlementPrice",
      Header: "قیمت تسویه با تامین کننده",
      minWidth: 100,
      Cell: ({ row }) => (
        <div className="text-center">{tools.formatPriceNumber(row.original.supplierSettlementPrice)}</div>
      ),
    },

    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش آیتم "
            onClick={() => {
              setModalType(2);
              setSelectedReserveItem(row.original);
              setShowModalReserveItem(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="کپی آیتم"
            onClick={() => {
              setModalType(3);
              setSelectedReserveItem(row.original);
              setShowModalReserveItem(true);
            }}
          >
            <i className="fa fa-copy text-small"></i>
          </Button>
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="قیمت گذاری و به‌روزرسانی گروه‌های تخفیف و کمیسیون"
            onClick={() => {
              setSelectedReserveItem(row.original);
              setShowModalReserveItemPricingAndCommission(true);
            }}
          >
            <i className="fa fa-list text-small"></i>
          </Button>
        </div>
      ),
    },
    {
      accessor: "reservationExpirationTime",
      Header: "ساعت اتمام فروش",
      minWidth: 120,
      Cell: ({ row }) => {
        const timeString = row.original.reservationExpirationTime;
        const formattedTime = timeString?.slice(0, 5); // Take only the first 5 characters (HH:mm)

        return <div className="text-center">{formattedTime}</div>;
      },
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: 90,
      maxWidth: 90,
    },

    {
      accessor: "minimumReserveCountPerDay",
      Header: "حداقل تعداد",
      minWidth: 100,
      Cell: ({ row }) => (
        <div className="text-center">
          {row.original.minimumReserveCountPerDay ? row.original.minimumReserveCountPerDay : "-"}
        </div>
      ),
    },
    {
      accessor: "defaultReserveCountPerDay",
      Header: "ظرفیت روزانه",
      minWidth: 100,
    },
    {
      accessor: "reservationByPhone",
      Header: "تماس تلفنی",
      minWidth: 100,
      Cell: ({ row }) => (
        <div className="text-center">{row.original.reservationByPhone ? row.original.reservationByPhone : "-"}</div>
      ),
    },
    {
      accessor: "supplierCompanyName",
      Header: "تامین کننده",
      minWidth: 100,
      Cell: ({ row }) => (
        <div className="text-center">{row.original.supplierCompanyName ? row.original.supplierCompanyName : "-"}</div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
